import React from "react";
import { Link } from "react-router-dom";
import { Button } from "semantic-ui-react";

const OrderComponentInvoiceNumber = ({ invoices = [] }) => {
    const getNumber = inv => (!!inv.beer ? `${inv.number}B` : inv.number);
    return (
        <>
            {invoices.map(inv => (
                <Link key={inv.id} title="Invoice number" to={`/invoice/${getNumber(inv)}`}>
                    {!inv.beer ? (
                        <Button compact size="mini">{`#${getNumber(inv)}`}</Button>
                    ) : (
                        <Button compact size="mini">
                            {`#${getNumber(inv)}`}
                        </Button>
                    )}
                </Link>
            ))}
        </>
    );
};

export default OrderComponentInvoiceNumber;
